export default "__VITE_ASSET__PX2Yxg0P__"